/**
 * @file コンポーネント：タブ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledTab = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledTabContentlist = styled.ul`
    &[data-on-color="gray"] {
        background-color: #ffffff;
    }

    &[data-on-color="main"] {
        background-color: #25292d;
    }

    &[data-on-color="sub"] {
        border-top: 1px solid #acadae;
        background-color: #25292d;
    }

    &[data-on-color="white"] {
        background-color: #d9d9d9;
    }
`;

export const StyledTabContentlistItem = styled.li`
    display: none;

    &.is-selected {
        display: block;
    }
`;

export const StyledTabTriggerAnchor = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 8px;

    &[data-on-color="gray"] {
        color: #212121;
    }

    &[data-on-color="main"] {
        color: #ffffff;
    }

    &[data-on-color="sub"] {
        color: #ffffff;
    }

    &[data-on-color="white"] {
        color: #000000;
    }

    &.is-disabled {
        pointer-events: none;

        &[data-on-color="gray"] {
            color: #6c757d;
        }

        &[data-on-color="main"] {
            color: #6c757d;
        }

        &[data-on-color="sub"] {
            color: #6c757d;
        }

        &[data-on-color="white"] {
            color: #acadae;
        }
    }

    &.is-selected {
        padding-bottom: 6px;
        border-bottom: 2px solid #7f97f8;
        font-weight: bold;

        &[data-on-color="gray"] {
            background-color: #ffffff;
        }

        &[data-on-color="main"] {
            background-color: #25292d;
        }

        &[data-on-color="white"] {
            background-color: #d9d9d9;
        }
    }
`;

export const StyledTabTriggerAnchorIcon = styled.span`
    width: 24px;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
`;

export const StyledTabTriggerAnchorText = styled.span`
    font-size: 11px;
    line-height: 16px;
`;

export const StyledTabTriggerlist = styled.ul`
    display: flex;
`;

export const StyledTabTriggerlistItem = styled.li`
    display: flex;
    flex-grow: 1;
`;
